import axios from './index';

import type { ApiResponse } from './dramas';

export type ContentFilterPlatform = 'ios' | 'android';

export type ContentWhitelistTargetType = 'drama';

export interface ContentFilterVersionItem {
    id: string;
    platform: ContentFilterPlatform;
    builder: string;
    enabled: boolean;
    created_by?: string | null;
    created_at?: string;
    updated_at?: string;
}

export interface ContentWhitelistItem {
    id: string;
    target_type: ContentWhitelistTargetType;
    target_id: string;
    banner: boolean;
    created_by?: string | null;
    /** 短剧展示标题 */
    title?: string | null;
    created_at?: string;
    updated_at?: string;
}

export interface ContentFilterVersionListParams {
    page?: number;
    size?: number;
    platform?: ContentFilterPlatform;
    enabled?: boolean;
}

export interface ContentWhitelistListParams {
    page?: number;
    size?: number;
    target_type?: ContentWhitelistTargetType;
    keyword?: string;
}

export interface ContentFilterVersionCreatePayload {
    platform: ContentFilterPlatform;
    builder: string;
}

export interface ContentFilterVersionUpdatePayload {
    enabled: boolean;
}

export interface ContentWhitelistCreatePayload {
    target_type: ContentWhitelistTargetType;
    target_ids: string[];
}

export interface ContentWhitelistUpdatePayload {
    banner: boolean;
}

export interface ContentWhitelistCreateResult {
    created: number;
    invalid: string[];
}

export const contentFilterVersionList = (params?: ContentFilterVersionListParams) =>
    axios<ApiResponse<ContentFilterVersionItem[]>>('/v1/content-filters/versions', {
        method: 'get',
        params,
    });

export const contentFilterVersionCreate = (data: ContentFilterVersionCreatePayload) =>
    axios<ApiResponse<ContentFilterVersionItem>>('/v1/content-filters/versions', {
        method: 'post',
        data,
    });

export const contentFilterVersionUpdate = (id: string, data: ContentFilterVersionUpdatePayload) =>
    axios<ApiResponse<ContentFilterVersionItem>>(`/v1/content-filters/versions/${id}`, {
        method: 'patch',
        data,
    });

export const contentFilterVersionDelete = (id: string) =>
    axios<ApiResponse>(`/v1/content-filters/versions/${id}`, {
        method: 'delete',
    });

export const contentWhitelistList = (params?: ContentWhitelistListParams) =>
    axios<ApiResponse<ContentWhitelistItem[]>>('/v1/content-filters/whitelist', {
        method: 'get',
        params,
    });

export const contentWhitelistCreate = (data: ContentWhitelistCreatePayload) =>
    axios<ApiResponse<ContentWhitelistCreateResult>>('/v1/content-filters/whitelist', {
        method: 'post',
        data,
    });

export const contentWhitelistUpdate = (id: string, data: ContentWhitelistUpdatePayload) =>
    axios<ApiResponse<ContentWhitelistItem>>(`/v1/content-filters/whitelist/${id}`, {
        method: 'patch',
        data,
    });

export const contentWhitelistDelete = (id: string) =>
    axios<ApiResponse>(`/v1/content-filters/whitelist/${id}`, {
        method: 'delete',
    });
